import type { DryRunResult, ResponseMode } from '@mailpilot/shared';
import type { Tone } from '../ui';

export const MODE_META: Record<ResponseMode, { label: string; short: string; tone: Tone; explain: string }> = {
  suggest: {
    label: 'Suggest only',
    short: 'Suggest',
    tone: 'primary',
    explain: 'Drafts a reply for you to review. Nothing is sent.',
  },
  acknowledge: {
    label: 'Automatic acknowledgement',
    short: 'Acknowledge',
    tone: 'info',
    explain: 'Sends your approved template once, then prepares the real reply for your review.',
  },
  auto_reply: {
    label: 'Controlled automatic reply',
    short: 'Auto reply',
    tone: 'warn',
    explain: 'AI writes and sends substantive replies only under this rule, using only the facts you supply. Use with care — you can require approval before each send.',
  },
};

export const WOULD_DO_TEXT: Record<DryRunResult['wouldDo'], string> = {
  nothing: 'Do nothing automatically. The message stays in your inbox for you to handle.',
  suggest: 'Draft a suggested reply for you to review. Nothing would be sent.',
  acknowledge: 'Send your acknowledgement template once, then prepare the real reply for your review.',
  auto_reply: 'Write and send an automatic reply under the matched rule.',
  auto_reply_pending_approval: 'Write an automatic reply and hold it for your approval before anything is sent.',
};
